<template>
  <div>
    <el-tabs v-model="activeName" type="border-card">
      <el-tab-pane
        :label="$l('INDEX.order_tab_base_information') || '基本信息'"
        name="base"
      >
        <ShipmentInfo
          ref="shipmentInfo"
          :shipmentCode="shipmentCode"
          :shipmentStatus.sync="shipmentStatus"
          :disabled="disabled || shipmentStatus !== 'B'"
          :readonly="readonly"
        />
        <slot name="button-group">
          <div class="d-flex justify-content-end mt-2 mb-2">
            <el-button
              v-if="!disabled && shipmentStatus === 'B'"
              type="primary"
              size="small"
              @click="() => $refs.shipmentInfo.save()"
            >
              {{ $l('INDEX.btn_save') || '保存' }}
            </el-button>
          </div>
        </slot>
      </el-tab-pane>
      <el-tab-pane
        :disabled="!shipmentCode"
        :label="$l('INDEX.tab_shipment_batch') || '交货批次'"
        name="batch"
        lazy
      >
        <ShipmentBatch
          :shipmentCode="shipmentCode"
          :disabled="disabled"
          :readonly="shipmentStatus !== 'R'"
          :sourceType="sourceType"
        />
      </el-tab-pane>
      <el-tab-pane
        :disabled="!shipmentCode"
        :label="$l('INDEX.tab_shipment_batch_box') || '产品清单'"
        name="goods"
        lazy
      >
        <ShipmentGoods
          :shipmentCode="shipmentCode"
          :disabled="disabled"
          :readonly="shipmentStatus !== 'B'"
        />
      </el-tab-pane>
      <el-tab-pane
        :disabled="!shipmentCode"
        :label="$l('INDEX.form_tab_shipment_container') || '装柜记录'"
        name="container"
        lazy
      >
        <ShipmentContainer
          :shipmentCode="shipmentCode"
          :disabled="disabled"
          :readonly="shipmentStatus !== 'B'"
        />
      </el-tab-pane>
      <el-tab-pane
        v-if="shipmentStatus != 'R'"
        :disabled="!shipmentCode"
        :label="$l('INDEX.group_booking_info') || '订舱信息'"
        name="booking"
        lazy
      >
        <ShipmentBooking
          :shipmentCode="shipmentCode"
          :disabled="disabled"
          :shipmentStatus="shipmentStatus"
        />
      </el-tab-pane>
      <el-tab-pane
        :disabled="!shipmentCode"
        :label="$l('INDEX.order_tab_shipment_packing_list') || '报关装箱清单'"
        name="box"
        lazy
      >
        <ShipmentPacking
          :shipmentCode="shipmentCode"
          :shipmentStatus="shipmentStatus"
        />
      </el-tab-pane>
      <el-tab-pane
        v-if="shipmentStatus === 'M'"
        :disabled="!shipmentCode"
        :label="$l('INDEX.tab_label_shipment_packingOrder') || '订单汇总'"
        name="order"
        lazy
      >
        <ShipmentOrder :shipmentCode="shipmentCode" :disabled="disabled" />
      </el-tab-pane>
      <el-tab-pane
        v-if="allowUploadFile"
        :disabled="!shipmentCode"
        :label="$l('INDEX.tab_shipment_doc') || '发运单文档'"
        name="doc"
        lazy
      >
        <ShipmentDoc :shipmentCode="shipmentCode" :disabled="disabled" />
      </el-tab-pane>
      <el-tab-pane
        :disabled="!shipmentCode"
        :label="$l('INDEX.order_tab_execution_log') || '执行日志'"
        name="log"
        lazy
      >
        <ShipmentLog :shipmentCode="shipmentCode" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import ShipmentInfo from './components/shipment-info'
import ShipmentContainer from './components/shipment-container'
import ShipmentBatch from './components/shipment-batch'
import ShipmentGoods from './components/shipment-goods'
import ShipmentBooking from './components/shipment-booking'
import ShipmentDoc from './components/shipment-doc'
import ShipmentLog from './components/shipment-log'
import ShipmentPacking from './components/shipment-packing'
import ShipmentOrder from './components/shipment-order'
export default {
  props: {
    shipmentCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },
    allowUploadFile: { type: Boolean, default: true },
    sourceType: { type: String, default: '' },
  },
  components: {
    ShipmentInfo,
    ShipmentContainer,
    ShipmentBatch,
    ShipmentGoods,
    ShipmentBooking,
    ShipmentLog,
    ShipmentDoc,
    ShipmentPacking,
    ShipmentOrder,
  },
  data() {
    return {
      activeName: 'base',
      shipmentStatus: '',
    }
  },
  methods: {
    reload() {
      this.$refs.shipmentInfo.loadData()
    },
  },
}
</script>
